export default function addTitleToErrorObject(errorObject, title = "Action failed") {
  return { ...errorObject, ...{ title } }
}
